import React from "react";

const CONTAINER_CLASSES =
  "group relative p-[2px] bg-white-button-border-unhover rounded-full hover:bg-white-button-border-hovered transition-all duration-300";
const BUTTON_CLASSES_BASE =
  "relative flex items-center gap-2 text-white-button-text-color leading-[140%] font-medium bg-white-button-unhover-color rounded-full shadow-lg shadow-gray-700/30 transition duration-300";
const BUTTON_CLASSES_HOVER =
  "hover:bg-white-button-hovered-color hover:shadow-gray-500/50";
const BLUR_EFFECT =
  "absolute inset-0 rounded-full border-[1px] border-gray-400/50 blur-md";

const WhiteButton = ({
  text = "Click me",
  onClick,
  type,
  padding = "px-5 py-2.5 md:px-6 md:py-4",
  textClassName = "text-sm md:text-lg",
  className = "",
  icon = null,
  disabled = false,
  ariaLabel = "",
}) => {
  // Enable hover only if onClick is provided
  const buttonClasses = onClick
    ? `${BUTTON_CLASSES_BASE} ${BUTTON_CLASSES_HOVER} ${padding}`
    : `${BUTTON_CLASSES_BASE} ${padding} cursor-default`;

  return (
    <div
      className={`${className} ${CONTAINER_CLASSES} ${
        disabled ? "opacity-50" : ""
      }`}
    >
      <button
        type={type}
        onClick={onClick}
        className={buttonClasses}
        disabled={disabled}
        aria-label={ariaLabel || text}
      >
        <span className={textClassName}>{text}</span>
        {icon && <span className="text-lg">{icon}</span>}
        <div className={BLUR_EFFECT} />
      </button>
    </div>
  );
};

export default WhiteButton;
